import hatsApi from '@/services/hatsApi'

export default {
  getAccount (id) {
    return hatsApi().get('/system/account/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Account.js